// extracted by mini-css-extract-plugin
module.exports = {"cart-item-buttons":"td-FUv","not-market-place":"WDiNrH","market-place":"_28rGvI","cart-item-button":"_3dsJAO","basket-button":"_3_o3vK"};